import React from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import CustomInput from "../../custom/custom-input/CustomInput";
import CustomSelect from "../../custom/custom-select";
import CustomInputWithUnits from "../../custom/custom-input-with-units/CustomInputWithUnits";
import { WEIGHT_UNITS } from "../../../mock";
import { MAX_RAILWAY_WAGONS_COUNT } from "../../../pages/orders/utils/railwayOrder";
import styles from "./UnifiedOrderCreation.module.scss";

export default function RailwayOrderFields(p) {
  const { t } = useTranslation();
  const { errors = {} } = p;
  const codeField = (name, label) => (
    <CustomInput
      labelText={label}
      placeholder={t("railwayOrder.codePlaceholder")}
      isBgGray
      value={p[name]}
      onChangeValue={p[`set${name[0].toUpperCase()}${name.slice(1)}`]}
      errorText={errors[name]}
    />
  );

  return (
    <>
      <div className={styles.fields}>
        <CustomSelect
          labelText={`${t("railwayOrder.wagonType")}*`}
          placeholder={t("railwayOrder.wagonTypePlaceholder")}
          options={p.wagonTypes}
          defaultValue={p.wagonType}
          returnObject
          onSubmit={p.setWagonType}
          errorText={errors.wagonType}
        />
        {p.categoryField}
        <CustomInputWithUnits
          labelText={t("railwayOrder.weightLabel")}
          isBgGray
          inputType="number"
          value={p.weight}
          onChangeValue={p.setWeight}
          errorText={errors.weight}
          units={WEIGHT_UNITS(t)}
          selectedUnit={p.weightUnit.key}
          onChangeUnit={p.setWeightUnit}
        />
        <CustomInput
          labelText={t("ordersCreateDesktop.detailsSection.volumeLabel")}
          isBgGray
          inputType="number"
          value={p.volume}
          onChangeValue={p.setVolume}
          errorText={errors.volume}
          prefixEnd={
            <span>
              {t("ordersCreateDesktop.detailsSection.volumeUnit")}
              <sup>3</sup>
            </span>
          }
        />
        <CustomInput
          labelText={t("railwayOrder.wagonsCount")}
          placeholder={t("unifiedOrder.quantityPlaceholder")}
          isBgGray
          inputType="number"
          value={p.isComplexTender ? "" : p.wagonsCount}
          isDisabled={p.isComplexTender}
          onChangeValue={(value) => {
            if (Number(value) > MAX_RAILWAY_WAGONS_COUNT) {
              toast.error(t("railwayOrder.wagonsCountTooLarge"));
              return;
            }
            p.setWagonsCount(value);
          }}
          errorText={p.isComplexTender ? undefined : errors.wagonsCount}
        />
        <CustomInput
          labelText={t("ordersCreateDesktop.detailsSection.temperatureLabel")}
          placeholder={t("unifiedOrder.temperaturePlaceholder")}
          isBgGray
          value={p.temperature}
          onChangeValue={p.setTemperature}
          errorText={errors.temperature}
        />
      </div>
      <div className={styles.cargoCodes}>
        {codeField("tnvedCode", t("railwayOrder.tnvedCode"))}
        {codeField("etsngCode", t("railwayOrder.etsngCode"))}
        {codeField("gngCode", t("railwayOrder.gngCode"))}
      </div>
    </>
  );
}
